<template>
    <div id="AddressDiv">
        <HeaderVue/>
        <div class="header">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-sm-12">
                      <div class="menu_popup" >
                        <a @click="goBackPopup()" style="color:#9e9e9e">
                          <i class="material-icons">
                              arrow_back
                          </i>
                        </a>
                      </div>
                      <h3 class="screen-title mt-13p">
                          <span class="float-left">
                              Health Cart
                          </span>
                          <!--<div class="float-left cont-number">
                                <h6>Call us at</h6>
                                <h5><a href="tel:+919025662566">+91 90256 62566</a></h5>
                            </div>-->
                          <span class="float-right gray-color">
                              Step 2 of 3
                          </span>
                      </h3>
                  </div>
              </div>
          </div>
        </div>
       
        <div class="container-fluid pick-address" v-bind:class="{'display-block' : isPage, 'display-none' : !isPage}">
          <div class="row">
              <div class="col-12">
                  <div class="alert alert-dark rounded-0 clearfix border-0" role="alert">
                      <span class="float-left">Patient Details</span>
                      <span class="float-right blue-color" v-on:click="addMember()">
                          <span class="badge add-badge badge-light float-left">
                              <i class="material-icons">add</i>
                          </span>
                          Add New
                      </span>
                  </div>
                  <ul class="patient-list mt-4" v-if="members">
                    <li v-if="members.user" :class="{'selected-address' : (members.user.userId == isMemberActiveId && isMe == true)}">
                        <div class="row">
                            <div class="col-8" v-on:click="isMemberActiveId = members.user.userId; setActiveMemberId(members.user)">
                                <i class="material-icons">check_circle</i>
                            </div>
                            <div class="col-2">
                                <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editMemberProfile(1)">
                                    <img src="static/images/pen-blue.svg" alt="">
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <p class="mt-2 mb-0">{{members.user.firstName + ' ' + members.user.lastName}}</p>
                                <p class="mb-0"v-if="members.user.age || (members.user.sex && members.user.sex.length > 0) ">{{members.user.age}}, {{(members.user.sex==='O'?'Other':((members.user.sex==='M')?'Male':((members.user.sex==='F')?'Female':'')))}}</p>
                                <p v-if="members.user.mobile">M: {{members.user.mobile}}</p>
                            </div>
                        </div>
                    </li>
                    <li v-for="(family, index) in members.family" :class="{'selected-address' : (family.memberId === isMemberActiveId && isMe == false)}" v-bind:key="index">
                        <div class="row">
                            <div class="col-8" v-on:click="isMemberActiveId = family.memberId; setActiveMemberId(family)">
                                <i class="material-icons">check_circle</i>
                            </div>
                            <div class="col-2">
                                <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editMember(family)">
                                    <img src="static/images/pen-blue.svg" alt="">
                                </button>
                            </div>
                            <div class="col-2" v-if="(family.memberId !== isMemberActiveId || isMe)" v-on:click="deleteMember(family)">
                                <button class="btn btn-link remove-btn p-0">
                                    <img src="static/images/close-black.svg" alt="">  
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <p class="mt-2 mb-0">{{family.firstName + ' ' + family.lastName}}</p>
                                <p class="mb-0" v-if="family.age || (family.sex && family.sex.length > 0) ">{{family.age}}, {{(family.sex==='O'?'Other':((family.sex==='M')?'Male':((family.sex==='F')?'Female':'')))}}</p>
                                <p v-if="family.mobile">M: {{family.mobile}}</p>
                            </div>
                        </div>
                    </li>
                  </ul>
              </div>
              <div class="col-12">
                  <div class="alert alert-dark rounded-0 clearfix border-0" role="alert">
                      <span class="float-left">Pickup Address</span>
                      <span class="float-right blue-color" v-on:click="addAddress()">
                          <span class="badge add-badge badge-light float-left">
                              <i class="material-icons">add</i>
                          </span>
                          Add New
                      </span>
                  </div>
                  <ul class="patient-list mt-4" v-if="addresses">
                      <li v-for="(address, index) in addresses" :key="index" :class="{'selected-address' : (address.addressId === isAddressActiveId)}">
                          <div class="row">
                              <div class="col-8" v-on:click="selectAddress(address)">
                                  <i class="material-icons">check_circle</i>
                              </div>
                              <div class="col-2">
                                  <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editAddress(address) ">
                                      <img src="static/images/pen-blue.svg" alt="">
                                  </button>
                              </div>
                              <div class="col-2" v-on:click="deleteAddress(address.addressId)" v-if="(address.addressId !== isAddressActiveId)">
                                  <button class="btn btn-link remove-btn p-0">
                                      <img src="static/images/close-black.svg" alt="">
                                  </button>
                              </div>
                          </div>
                          <div class="row" >
                              <div class="col-sm-12" >
                                  <address class="mt-2">
                                      <!--{{address.address}}, {{address.Location.locationName}}, <br />{{address.City.cityName}} - {{address.zipCode}}. -->
                                      {{address.flatNo ? address.flatNo +', ' : '' }} {{address.address}}, {{address.landmark ? address.landmark +', ' : '' }} {{address.Location.locationName}}, <br />{{address.City.cityName}} - {{address.zipCode}}. 

                                            <!--M: {{address.mobile}}-->
                                  </address>
                              </div>
                          </div>
                      </li>
                      <!-- <li>
                          <div class="row">
                              <div class="col-sm-8">
                                  <i class="material-icons">check_circle</i>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-sm-12">
                                  <address class="mt-2">
                                      #150/162, 2nd Main Road, J R Layout, Kaladipet, Chennai - 600019. Next to Divya Joyothi School, M: 0123456789
                                  </address>
                              </div>
                          </div>
                      </li> -->
                  </ul>
              </div>
              <div class="col-12">
                  <!-- <form data-vv-scope="coupon" @submit.prevent="applyCoupon()">
                    <div class="input-group mt-0" >
                        <input type="text" class="form-control text-uppercase" name="couponCode" data-vv-as="coupon code" v-model="couponCode" v-on:keyup="couponError='';" v-validate="'required|max:25'" placeholder="Coupon code" aria-label="Coupon code">
                        <span class="input-group-btn">
                            <button class="btn btn-link" type="button" @click.prevent="applyCoupon()">Apply</button>
                        </span>
                    </div>
                    <span v-show="errors.has('coupon.couponCode')" class="text-danger">{{ errors.first('coupon.couponCode') }}</span>
                    <span v-show="!errors.has('coupon.couponCode') && couponError" v-bind:class="{'text-danger': !isSuccessCoupon,'green-color': isSuccessCoupon}">{{ couponError }}</span>
                  </form> -->
                  <!-- <div id="accordion" class="mt-3" role="tablist">
                      <div class="card">
                            <div class="card-header" role="tab" id="headingOne">
                                <h5 class="pb-2 mb-0 border-bottom">
                                    <a data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="black-color collapsed">
                                        Test Details
                                        <i class="material-icons float-right"></i>
                                    </a>
                                </h5>
                            </div>
                            <div id="collapseOne" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#sideBar">
                                <div class="card-body pb-0 pt-0">
                                    <div class="table-responsive">
                                        <table class="table price-table">
                                            <tr>
                                                <td class="border-bottom"> 
                                                  <span class="black-color">{{$localStorage.get('sl').labName}}</span><br>
                                                  <span class="">{{$localStorage.get('sl').labLocation + ', ' + $localStorage.get('sl').labCity + '-' + $localStorage.get('sl').labZipCode}}</span>
                                                </td>
                                                <td class="border-bottom"></td>
                                            </tr>
                                            <tr v-for="(cost, index) in testCosts.priceDetails" :key="index">
                                                <td class="black-color border-bottom">{{cost.aliasName}}</td>
                                                <td class="text-right black-color border-bottom">
                                                  Rs. {{cost.ourPrice}}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div id="collapseTwo" class="collapse show" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="card-body pb-0 pt-0">
                                    <div class="table-responsive">
                                        <table class="table price-table">
                                            <tr>
                                                <td>Order Value</td>
                                                <td class="text-right">Rs. {{payinfo.total}}</td>
                                            </tr>
                                            <tr v-if="payinfo.phlebotomistFee > 0" class="black-color">
                                                <td>Phlebotomist Fee</td>
                                                <td class="text-right">Rs. {{payinfo.phlebotomistFee}}</td>
                                            </tr>
                                            <tr v-if="payinfo.mrpTotal != payinfo.subTotal" class="black-color">
                                                <td>Sub Total</td>
                                                <td class="text-right">Rs. {{payinfo.subTotal}}</td>
                                            </tr>
                                            <tr v-if="payinfo.couponFee > 0" class="black-color">
                                                <td>Coupon Discount</td>
                                                <td class="text-right green-color">- Rs. {{payinfo.couponFee}}</td>
                                            </tr>
                                            <tr v-if="payinfo.phlebotomyFeeWaiver > 0" class="black-color">
                                                <td>Coupon Discount</td>
                                                <td class="text-right green-color">-Rs. {{payinfo.phlebotomyFeeWaiver}}</td>
                                            </tr>
                                            <tr class="black-color">
                                                <td>Amount Payable</td>
                                                <td class="text-right">Rs. {{payinfo.grandTotal}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div> -->
                  <!-- <button class="btn btn-primary full-width mt-4" @click.prevent.self="goPayment()">Make Payment</button> -->
              </div>
          </div>
        </div>
        <div class="fixed-footer p-0" id="fixed-footer" v-bind:class="{'display-block' : isPage, 'display-none' : !isPage}">
          <div id="accordion" class="test-details-popover" role="tablist">
              <div class="card m-0">
                  <div class="card-header" role="tab" id="headingOne">
                      <h5 class="mb-0">
                          <a class="collapsed gray-color" data-toggle="collapse" href="#testDetails" aria-expanded="true" aria-controls="testDetails">
                              Test Details
                              <span>{{$localStorage.get('st') && $localStorage.get('st').length > 0 ? '(' + $localStorage.get('st').length + ')' : '' }}</span>
                              <i class="material-icons float-right"></i>
                          </a>
                      </h5>
                  </div>
                  <div id="testDetails" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                      <div class="card-body">
                          <div class="row">
                              <div class="col-12">
                                  <div class="lab display-flex no-border p-0 mt-3 bg-tranparent">
                                      <div class="flex-box">
                                          <div class="lab-logo">
                                              <img v-if="selectedLab.logo && selectedLab.logo.length > 0" :src="selectedLab.logo" />
                                          </div>
                                      </div>
                                      <div class="flex-box">
                                          <p class="black-color font-weight-bold mb-2">
                                              {{$localStorage.get('sl').labName}}
                                          </p>
                                          <p class="mt-0 mb-1">{{$localStorage.get('sl').branch.branchLocation + ', ' + $localStorage.get('sl').branch.branchCity + '-' + $localStorage.get('sl').branch.branchZipCode}}</p>
                                          <!-- <a class="text-uppercase font-weight-bold" href="">
                                              Change Lab
                                          </a> -->
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="row scroll-test">
                              <div class="col-12">
                                  <div class="table-responsive test-conformation">
                                      <table class="table">
                                          <thead>
                                            <tr>
                                                <th class="no-border">
                                                    Test Name
                                                </th>
                                                <th class="text-right no-border">

                                                </th>
                                                <th class="no-border text-right">
                                                    Price
                                                </th>
                                            </tr>
                                          </thead>
                                          <tbody class="black-color">
                                            <tr v-for="(cost, index) in testCosts.priceDetails" :key="index">
                                                <td>
                                                    {{cost.aliasName}}
                                                </td>
                                                <td>

                                                </td>
                                                <td>
                                                    <p class="float-right mt-1 mb-0 price-tag">
                                                          Rs. {{cost.ourPrice}}
                                                    </p>
                                                </td>
                                            </tr>
                                          </tbody>
                                          <!-- <tfoot class="border-bottom">
                                              <tr>
                                                  <td>Sub Total</td>
                                                  <td>

                                                  </td>
                                                  <td>
                                                      <p class="float-right mt-1 mb-0 price-tag">
                                                          Rs. 2199
                                                      </p>
                                                  </td>
                                              </tr>
                                          </tfoot> -->
                                      </table>
                                  </div>
                                  <div class="table-responsive">
                                      <table class="table price-table">
                                          <tbody>
                                              <tr>
                                                  <td>Order Value</td>
                                                  <td class="text-right">Rs. {{payinfo.total}}</td>
                                              </tr>
                                              <tr v-if="payinfo.phlebotomistFee > 0" class="black-color">
                                                  <td>Phlebotomist Fee</td>
                                                  <td class="text-right">Rs. {{payinfo.phlebotomistFee}}</td>
                                              </tr>
                                              <tr v-if="payinfo.mrpTotal != payinfo.subTotal" class="black-color">
                                                  <td>Sub Total</td>
                                                  <td class="text-right">Rs. {{payinfo.subTotal}}</td>
                                              </tr>
                                              <tr v-if="payinfo.couponFee > 0" class="black-color">
                                                  <td>Coupon Discount</td>
                                                  <td class="text-right green-color">- Rs. {{payinfo.couponFee}}</td>
                                              </tr>
                                              <tr v-if="payinfo.phlebotomyFeeWaiver > 0" class="black-color">
                                                  <td>Coupon Discount</td>
                                                  <td class="text-right green-color">-Rs. {{payinfo.phlebotomyFeeWaiver}}</td>
                                              </tr>
                                              <tr class="black-color">
                                                  <td>Amount Payable</td>
                                                  <td class="text-right">Rs. {{payinfo.grandTotal}}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <button class="btn btn-primary full-width fixed-button"  @click.prevent.self="goPayment()">
              Proceed to payment
          </button>
        </div>
        <div class="container-fluid pick-address" v-bind:class="{'display-block' : isAddAddressPage, 'display-none' : !isAddAddressPage}">
            <form data-vv-scope="addAddress">
              <div class="row">
                  <div class="col-12">
                      <div class="alert alert-dark rounded-0 clearfix border-0" role="alert">
                          <span class="float-left">Add Address</span>
                      </div>
                      <div class="clearfix mt-4 line-textbox">
                        <div class="form-group" v-show="false">
                            <label>Full name</label>
                            <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="addAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                            <span v-show="errors.has('addAddress.fullName')" class="text-danger">{{ errors.first('addAddress.fullName') }}</span>
                        </div>
                        <div class="form-group">
                              <label>Flat No, Floor and Apt Name</label>
                              <input type="text" class="form-control" name="flatNo" id="flatNo" data-vv-as="flatNo" v-model="addAddressFields.flatNo" maxlength="500" v-validate="'required'" />
                              <span v-show="errors.has('addAddress.flatNo')" class="text-danger">Flat No, Floor and Apt Name is required.</span>
                          </div>
                          <div class="form-group">
                              <label>Street Address</label>
                              <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="addAddressFields.address" v-on:blur="addressChanged(1)" v-validate="'required'" />
                              <span v-show="errors.has('addAddress.address')" class="text-danger">{{ errors.first('addAddress.address') }}</span>
                          </div>
                          <div class="form-group">
                              <label>Landmark <span class="locality-message">(Optional)</span></label>
                              <input type="text" class="form-control" name="landmark" id="landmark" data-vv-as="landmark" v-model="addAddressFields.landmark" maxlength="300"/>
                              <span v-show="errors.has('addAddress.landmark')" class="text-danger">{{ errors.first('addAddress.landmark') }}</span>
                          </div>
                        <div class="form-group address-locality-search">
                              <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                              <span v-on:click="onFocusLocality()">
                                <input type="text" class="form-control" 
                                  placeholder="Enter Locality" 
                                  aria-label="" name="x" 
                                  list="mycarousel" 
                                  autocomplete="off" 
                                  minlength="3" 
                                  v-model="addAddressFields.zipcode"
                                  v-on:focus="onFocusLocality()" 
                                  disabled="true">
                              </span>
                              <span v-show="errors.has('addAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                              <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                              <div class="test-option full-width mt-4 scrollbar locality" v-bind:style="{ display: onBlurKey}">
                                <div class="popular-test focus-search p-0">
                                    <ul class="p-0 m-0">
                                        <li class="p-2" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 2)">
                                            {{item.locationName+'-'+item.locationZipCode}}
                                        </li>
                                        <li v-if="locationList.length === 0" class="text-center"> --- No Locations ---</li>
                                        <li v-if="locationList.length === 0" class="p-2 color-blue text-center" v-on:click.self="selectLocation($event, undefined, 3)">
                                            + Add Location
                                        </li>
                                        <li v-if="locationList.length !== 0" class="p-2 color-blue " v-on:click.self="selectLocation($event, undefined, 3)">
                                            + Add Location
                                        </li>
                                    </ul>
                                </div>
                            </div>
                          </div>
                          
                        <div class="form-group" v-if="showLocOther">
                              <label>New Pincode</label>
                              <input type="text" class="form-control" ref="newPincodeAdd" name="locationPincode" id="locationPincode" v-model="addAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(1)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                              <span v-show="errors.has('addAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                              <!--<span v-show="otherPincodeError" class="text-danger">The Pincode field must be a number.</span>-->
                          </div>
                        <div class="form-group" v-if="showLocOther">
                            <label>New Location</label>
                            <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="addAddressFields.locationOther" v-on:blur="addressChanged(1)" v-validate="'required'"/>
                            <span v-show="errors.has('addAddress.locationOther')" class="text-danger">{{ errors.first('addAddress.locationOther') }}</span>
                        </div>
                        <div class="form-group">
                            <p class="black-color"><span>{{stateCityDisp}}</span></p>
                        </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div id="myMapAdd"  style="width:100%;height:95%;background:#ccc;"></div>
                  </div>
                </div>
                <div class="row mt-25">
                  <div class="col-6">
                      <button class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</button>
                  </div>
                  <div class="col-6">
                      <button class="btn btn-primary full-width" type="button" v-on:click="saveAddress()">Save</button>
                  </div>
              </div>
            </form>
        </div>
        <div class="container-fluid pick-address" v-bind:class="{'display-block' : isEditAddressPage, 'display-none' : !isEditAddressPage}">
            <form data-vv-scope="editAddress">
              <div class="row">
                  <div class="col-12">
                    <div class="alert alert-dark rounded-0 clearfix border-0" role="alert">
                        <span class="float-left">Edit Address</span>
                    </div>
                    <div class="clearfix mt-4 line-textbox">
                      <div class="form-group" v-show="false">
                          <label>Full name</label>
                          <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="editAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                          <span v-show="errors.has('editAddress.fullName')" class="text-danger">{{ errors.first('editAddress.fullName') }}</span>
                      </div>
                      <div class="form-group">
                          <label>Flat No, Floor and Apt Name</label>
                          <input type="text" class="form-control" name="flatNo" id="flatNo" data-vv-as="flatNo" v-model="editAddressFields.flatNo" v-on:blur="addressChanged(2)" v-validate="'required'" />
                          <span v-show="errors.has('editAddress.flatNo')" class="text-danger">Flat No, Floor and Apt Name is required.</span>
                      </div>
                      <div class="form-group">
                          <label>Address</label>
                          <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="editAddressFields.address" v-on:blur="addressChanged(2)" v-validate="'required'" />
                          <span v-show="errors.has('editAddress.address')" class="text-danger">{{ errors.first('editAddress.address') }}</span>
                      </div>
                      <div class="form-group">
                          <label>Landmark <span class="locality-message">(Optional)</span></label>
                          <input type="text" class="form-control" name="landmark" id="landmark" data-vv-as="landmark" v-model="editAddressFields.landmark" v-on:blur="addressChanged(2)"/>
                          <span v-show="errors.has('editAddress.landmark')" class="text-danger">{{ errors.first('editAddress.landmark') }}</span>
                      </div>
                      <div class="form-group address-locality-search" >
                          <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                          <span v-on:click="onFocusLocality()">
                              <input type="text" class="form-control" 
                              placeholder="Enter Locality" 
                              aria-label="" name="x" 
                              list="mycarousel" 
                              autocomplete="off" 
                              minlength="3" 
                              v-model="editAddressFields.zipcode"
                              v-on:focus="onFocusLocality()" 
                              disabled="true">
                          </span>
                          
                          <!--<input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                            ref="pincodeEdit"
                            aria-label=""  
                            list="mycarousel" 
                            autocomplete="off" 
                            minlength="3" 
                            v-model="editAddressFields.zipcode" 
                            v-on:keyup="searchLocality(1)"
                            v-on:keyup.enter="searchLocality(1)" 
                            v-on:blur="closeBlock()"
                            v-on:focus="$refs.pincodeEdit.select();" 
                            v-validate="'required'">-->
                          <span v-show="errors.has('editAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                          <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                      </div>
                      <div class="form-group" v-if="showLocOther">
                          <label>New Pincode</label>
                          <input type="text" class="form-control" ref="newPincodeEdit" name="locationPincode" id="locationPincode" v-model="editAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(2)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                          <span v-show="errors.has('editAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                      </div>
                      <div class="form-group" v-if="showLocOther">
                          <label>New Location</label>
                          <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="editAddressFields.locationOther" v-on:blur="addressChanged(2)" v-validate="'required'"/>
                          <span v-show="errors.has('editAddress.locationOther')" class="text-danger">{{ errors.first('editAddress.locationOther') }}</span>
                      </div>
                      <div class="form-group">
                          <label>{{stateCityDisp}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div id="myMapVal"  style="width:100%;height:95%;background:#ccc"></div>
                  </div>
                </div>
              <div class="row mt-25">
                  <div class="col-6">
                      <button class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</button>
                  </div>
                  <div class="col-6">
                      <button class="btn btn-primary full-width" type="button" v-on:click="updateAddress()">Update</button>
                  </div>
              </div>
            </form>
        </div>
        <FooterVue />
        <!--<div class="modal fade" id="addAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog  modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="menu">
                          <a href="javascript:void(0)"  data-dismiss="modal" aria-label="Close" class="black-color">  
                              <i class="material-icons">
                                  arrow_back
                              </i>
                          </a>
                        </div>
                        <h3 class="screen-title mt-13p" id="exampleModalLabel">Add Address</h3>
                    </div>
                    <div class="modal-body">
                      <form data-vv-scope="addAddress">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="clearfix mt-4 line-textbox">
                                <div class="form-group" v-show="false">
                                    <label>Full name</label>
                                    <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="addAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                                    <span v-show="errors.has('addAddress.fullName')" class="text-danger">{{ errors.first('addAddress.fullName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Mobile</label>
                                    <input type="phone" class="form-control" name="mobile" id="mobile" data-vv-as="mobile" v-model="addAddressFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                    <span v-show="errors.has('addAddress.mobile')" class="text-danger">{{ errors.first('addAddress.mobile') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Address</label>
                                    <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="addAddressFields.address" v-on:blur="addressChanged(1)" v-validate="'required'" />
                                    <span v-show="errors.has('addAddress.address')" class="text-danger">{{ errors.first('addAddress.address') }}</span>
                                </div>
                                <div class="form-group address-locality-search">
                                      <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeAdd"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="addAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(2)"
                                        v-on:keyup.enter="searchLocality(2)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeAdd.select();" 
                                        v-validate="'required'">
                                      <span v-show="errors.has('addAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                                      <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                                      <div class="test-option full-width mt-4 scrollbar locality" v-bind:style="{ display: onBlurKey}">
                                        <div class="popular-test focus-search p-0">
                                            <ul class="p-0 m-0">
                                                <li class="p-2" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 2)">
                                                    {{item.locationName+'-'+item.locationZipCode}}
                                                </li>
                                                <li v-if="locationList.length === 0" class="text-center"> --- No Locations ---</li>
                                                <li v-if="locationList.length === 0" class="p-2 color-blue text-center" v-on:click.self="selectLocation($event, undefined, 3)">
                                                    + Add Location
                                                </li>
                                                <li v-if="locationList.length !== 0" class="p-2 color-blue " v-on:click.self="selectLocation($event, undefined, 3)">
                                                    + Add Location
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                  </div>
                                  
                                <div class="form-group" v-if="showLocOther">
                                      <label>New Pincode</label>
                                      <input type="text" class="form-control" name="locationPincode" id="locationPincode" v-model="addAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(1)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                                      <span v-show="errors.has('addAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                                  </div>
                                <div class="form-group" v-if="showLocOther">
                                    <label>New Location</label>
                                    <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="addAddressFields.locationOther" v-on:blur="addressChanged(1)" v-validate="'required'"/>
                                    <span v-show="errors.has('addAddress.locationOther')" class="text-danger">{{ errors.first('addAddress.locationOther') }}</span>
                                </div>
                                <div class="form-group">
                                    <p class="black-color"><span>{{stateCityDisp}}</span></p>
                                </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div id="myMapAdd"  style="width:100%;height:95%;background:#ccc;"></div>
                          </div>
                        </div>
                        <div class="fixed-footer p-0" id="fixed-footer-address"> 
                            <div class="row mt-6">
                                <div class="col-6">
                                      <a class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</a>
                                  </div>
                                  <div class="col-6">
                                      <button class="btn btn-primary full-width" type="button" @click.prevent="saveAddress()">Save</button>
                                  </div>
                            </div>
                        </div>
                      </form>
                    </div>
                </div>
            </div>
        </div>-->
        <!--<div class="modal fade" id="editAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Address</h5>
                    </div>
                    <div class="modal-body">
                        <form data-vv-scope="editAddress">
                          <div class="row">
                            <div class="col-sm-6">
                                <div class="clearfix mt-4 line-textbox">
                                  <div class="form-group" v-show="false">
                                      <label>Full name</label>
                                      <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="editAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                                      <span v-show="errors.has('editAddress.fullName')" class="text-danger">{{ errors.first('editAddress.fullName') }}</span>
                                  </div>
                                  <div class="form-group">
                                      <label>Mobile</label>
                                      <input type="phone" class="form-control" name="mobile" id="mobile" data-vv-as="mobile" v-model="editAddressFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                      <span v-show="errors.has('editAddress.mobile')" class="text-danger">{{ errors.first('editAddress.mobile') }}</span>
                                  </div>
                                  <div class="form-group">
                                      <label>Address</label>
                                      <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="editAddressFields.address" v-on:blur="addressChanged(2)" v-validate="'required'" />
                                      <span v-show="errors.has('editAddress.address')" class="text-danger">{{ errors.first('editAddress.address') }}</span>
                                  </div>
                                  <div class="form-group address-locality-search">
                                      <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeEdit"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="editAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(1)"
                                        v-on:keyup.enter="searchLocality(1)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeEdit.select();" 
                                        v-validate="'required'">
                                      <span v-show="errors.has('editAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                                      <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                                      <div class="test-option full-width mt-4 scrollbar locality" v-bind:style="{ display: onBlurKey}">
                                        <div class="popular-test focus-search p-0">
                                            <ul class="p-0 m-0">
                                                <li class="p-2" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 1)">
                                                    {{item.locationName+'-'+item.locationZipCode}}
                                                </li>
                                                <li v-if="locationList.length === 0" class="text-center"> --- No Locations ---</li>
                                                <li v-if="locationList.length === 0" class="p-2 color-blue text-center" v-on:click.self="selectLocation($event, undefined, 3)">
                                                    + Add Location
                                                </li>
                                                <li v-if="locationList.length !== 0" class="p-2 color-blue " v-on:click.self="selectLocation($event, undefined, 3)">
                                                    + Add Location
                                                </li>
                                            </ul>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="form-group" v-if="showLocOther">
                                      <label>New Pincode</label>
                                      <input type="text" class="form-control" name="locationPincode" id="locationPincode" v-model="editAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(2)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                                      <span v-show="errors.has('editAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                                  </div>
                                  <div class="form-group" v-if="showLocOther">
                                      <label>New Location</label>
                                      <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="editAddressFields.locationOther" v-on:blur="addressChanged(2)" v-validate="'required'"/>
                                      <span v-show="errors.has('editAddress.locationOther')" class="text-danger">{{ errors.first('editAddress.locationOther') }}</span>
                                  </div>
                                  <div class="form-group">
                                      <label>{{stateCityDisp}}</label>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div id="myMapVal"  style="width:100%;height:95%;background:#ccc"></div>
                            </div>
                          </div>
                          <div class="fixed-footer p-0" id="fixed-footer-address"> 
                            <div class="row mt-6">
                                <div class="col-6">
                                      <a class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</a>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary full-width" type="button" @click.prevent="updateAddress()">Update</button>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>-->
        <div class="modal fade" id="editMemberProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!--<div class="modal-header">
                        <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Profile Details</h5>
                    </div>-->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Edit Profile Details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                      <div class="form-content line-textbox">
                        <form data-vv-scope="edit">
                          <!-- <div class="clearfix">
                              <div class="testimonial-dp">
                              </div>
                              <p class="blue-color mt-5 float-left">Add Photo</p>
                          </div> -->
                          <div class="clearfix">
                              <div class="row">
                                  <div class="col-sm-6">
                                      <div class="form-group">
                                          <label>First Name</label>
                                          <input class="form-control" type="text" name="firstName" data-vv-as="first name" v-model="editMemberObj.firstName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                          <span v-show="errors.has('edit.firstName')" class="text-danger">{{ errors.first('edit.firstName') }}</span>
                                      </div>
                                  </div>
                                  <div class="col-sm-6">
                                      <div class="form-group">
                                          <label>Last Name</label>
                                          <input class="form-control" name="lastName" type="text" data-vv-as="last name" v-model="editMemberObj.lastName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                          <span v-show="errors.has('edit.lastName')" class="text-danger">{{ errors.first('edit.lastName') }}</span>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-6">
                                      <div class="form-group">
                                          <label>Gender</label>
                                          <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                              <label class="form-check-label">
                                                  <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'M')?true:false"> Male
                                              </label>
                                          </div>
                                          <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                              <label class="form-check-label">
                                                  <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'F')?true:false"> Female
                                              </label>
                                          </div>
                                          <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                              <label class="form-check-label">
                                                  <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="O" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'O')?true:false"> Other
                                              </label>
                                          </div>
                                          
                                      </div>
                                  </div>
                                  <!--<div class="col-sm-6">
                                      <div class="form-group">
                                          <label>Date of birth</label>
                                          <div class="input-group dobBorderRemoval">
                                              <datepicker class="form-control" name="dob" id="dob" v-model="editMemberObj.dob" data-vv-as="date of birth" :format="'dd/MM/yyyy'" :disabled="editMemberObj.disabled" v-validate="'required'" required></datepicker>
                                              <span class="input-group-btn">
                                                  <button class="btn btn-link white-bg" type="button">
                                                      <img src="static/images/calender.svg" class="m-0" alt="" onClick="document.getElementById('dob').focus()">
                                                  </button>
                                              </span>
                                          </div>
                                          <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                      </div>
                                  </div>-->
                                  <div class="col-sm-6">
                                          <div class="form-group" >
                                              <label>Date of birth</label>
                                              <div class="row">
                                                  <div class="col-4">
                                                      <select class="form-control" name="year" id="year"  v-model="year" v-on:change="getNumberOfDays()">
                                                          <option value="" class="dobOptionColor" disabled selected>YYYY</option>
                                                          <option v-for="(dobYear, index) in dobYears" v-bind:value="dobYear" :key='index'>{{dobYear}}</option>
                                                      </select>
                                                  </div>
                                                  <div class="col-4">
                                                      <select class="form-control" name="month" id="month" v-model="month" v-on:change="getNumberOfDays()">
                                                          <option value="" class="dobOptionColor" disabled selected>MMM</option>
                                                          <option value="01">Jan</option>
                                                          <option value="02">Feb</option>
                                                          <option value="03">Mar</option>
                                                          <option value="04">Apr</option>
                                                          <option value="05">May</option>
                                                          <option value="06">Jun</option>
                                                          <option value="07">Jul</option>
                                                          <option value="08">Aug</option>
                                                          <option value="09">Sep</option>
                                                          <option value="10">Oct</option>
                                                          <option value="11">Nov</option>
                                                          <option value="12">Dec</option>
                                                      </select>
                                                  </div>
                                                  <div class="col-4">
                                                  <select class="form-control" name="ddate" id="ddate" v-model="ddate">
                                                      <option value="" class="dobOptionColor" disabled selected>DD</option>
                                                      <option v-for="(dobDateVal, index) in dobDate" v-bind:value="dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''" :key='index'>{{dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : '' }}</option>
                                                  </select>
                                                  </div>
                                                  <div class="col-sm-12">
                                                      <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                                  </div>
                                              </div>
                                          </div>
                                            <!--<div class="form-group">
                                                <label>Date of birth</label>
                                                <div class="input-group dobBorderRemoval">
                                                    <datepicker class="form-control" name="dob" id="dob" v-model="dob" data-vv-as="date of birth" :format="'dd/MM/yyyy'" :disabled="disabled" v-validate="'required'" required></datepicker>
                                                    <span class="input-group-btn">
                                                        <button class="btn btn-link white-bg" type="button">
                                                            <img src="static/images/calender.svg" class="m-0" alt="" onClick="document.getElementById('dob').focus()">
                                                        </button>
                                                    </span>
                                                </div>
                                                <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                            </div>-->
                                        </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-6">
                                      <div class="form-group">
                                          <label>Mobile</label>
                                          <input class="form-control" type="text" name="phone1" data-vv-as="mobile no." v-model="editMemberObj.phone1" v-validate="'required|numeric|min:10|max:10'">
                                          <span v-show="errors.has('edit.phone1')" class="text-danger">{{ errors.first('edit.phone1') }}</span>
                                      </div>
                                  </div>
                                  <div class="col-sm-6">                                              
                                      <div class="form-group">
                                          <label>Alternate Phone No.</label>
                                          <input class="form-control" type="text" name="phone2" data-vv-as="alternate phone no." v-model="editMemberObj.phone2" v-validate="'numeric|min:10|max:10'">
                                          <span v-show="errors.has('edit.phone2')" class="text-danger">{{ errors.first('edit.phone2') }}</span>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-6">
                                      <div class="form-group">
                                          <label>Email</label>
                                          <input style="background-color: #fff; cursor: not-allowed" class="form-control" type="email" name="email" data-vv-as="email address" v-model="editMemberObj.email" v-validate="'required|email|max:100'" :disabled="true">
                                          <i style="font-size: 18px; color: #000; text-align: right; float: right; margin-top: -25px; margin-right: 10px;" class="fa">&#xf023;</i>
                                          <span v-show="errors.has('edit.email')" class="text-danger">{{ errors.first('edit.email') }}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="row">
                              <!-- <div class="col-6">
                              </div> -->
                            <div class="col-6">
                                <button class="btn  btn-link full-width" v-on:click="cancelMember(1)">Cancel</button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary full-width fly-msg" :disabled="(errors.any())" @click.prevent="saveProfile()">Update</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editPatientProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <!--<div class="modal-header">
                        <button type="button" class="close black-color " data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Patient Details</h5>
                    </div>-->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Edit Profile Details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateMember" data-vv-scope="editMember">
                          <div class="clearfix line-textbox">
                              <div class="form-group">
                                  <label>Patient First Name*</label>
                                  <input type="text" class="form-control" ref="editMemberFirstName" name="firstName" id="firstName" maxlength="50" data-vv-as="first name" v-model="editMemberFields.firstName" v-validate="'required|alpha_spaces|max:50'" />
                                  <span v-show="errors.has('editMember.firstName')" class="text-danger">{{ errors.first('editMember.firstName') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Patient Last Name*</label>
                                  <input type="text" class="form-control" name="lastName" id="lastName" maxlength="50" data-vv-as="last name" v-model="editMemberFields.lastName" v-validate="'required|alpha_spaces|max:50'" />
                                  <span v-show="errors.has('editMember.lastName')" class="text-danger">{{ errors.first('editMember.lastName') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Mobile*</label>
                                  <input type="text" class="form-control" name="mobile" v-mask="'##########'" id="mobile" maxlength="50" data-vv-as="last name" v-model="editMemberFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                  <span v-show="errors.has('editMember.mobile')" class="text-danger">{{ errors.first('editMember.mobile') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Gender*</label>
                                  <br>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="editMemberFields.sex"> Male
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="editMemberFields.sex"> Female
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="O" v-model="editMemberFields.sex"> Other
                                      </label>
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label>Age*</label>
                                  <input type="text" class="form-control" name="age" id="age" data-vv-as="age" v-model="editMemberFields.age" v-validate="'required|numeric|max:2'" />
                                  <span v-show="errors.has('editMember.age')" class="text-danger">{{ errors.first('editMember.age') }}</span>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-6">
                                  <button class="btn  btn-link full-width" v-on:click="cancelMember(2)">Cancel</button>
                              </div>
                              <div class="col-6">
                                  <button class="btn btn-primary full-width" type="submit">Update</button>
                              </div>
                          </div>
                      </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade " id="addPatientProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="menu_popup">
                          <a href="javascript:void(0)"  data-dismiss="modal" aria-label="Close" style="color:#969696">  
                              <i class="material-icons">
                                  arrow_back
                              </i>
                          </a>
                        </div>
                        <h3 class="screen-title mt-13p" id="exampleModalLabel">Add Patient Details</h3>
                        <!-- <h5 class="modal-title" id="exampleModalLabel"> Add Patient Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                       <form @submit.prevent="saveMember" data-vv-scope="addMember">
                            <div class="clearfix mt-4 line-textbox">
                                <div class="form-group">
                                    <label>Patient First Name*</label>
                                    <input type="text" class="form-control" name="firstName" id="firstName" maxlength="50" data-vv-as="first name" v-model="addMemberFields.firstName" v-validate="'required|alpha_spaces|max:50'" />
                                    <span v-show="errors.has('addMember.firstName')" class="text-danger">{{ errors.first('addMember.firstName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Patient Last Name*</label>
                                    <input type="text" class="form-control" name="lastName" id="lastName" maxlength="50" data-vv-as="last name" v-model="addMemberFields.lastName" v-validate="'required|alpha_spaces|max:50'" />
                                    <span v-show="errors.has('addMember.lastName')" class="text-danger">{{ errors.first('addMember.lastName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Mobile*</label>
                                    <input type="text" class="form-control" name="mobile" id="mobile" v-mask="'##########'" maxlength="50" data-vv-as="mobile" v-model="addMemberFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                    <span v-show="errors.has('addMember.mobile')" class="text-danger">{{ errors.first('addMember.mobile') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Gender*</label>
                                    <br>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="addMemberFields.sex"> Male
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="addMemberFields.sex"> Female
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="O" v-model="addMemberFields.sex"> Other
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Age*</label>
                                    <input type="text" class="form-control" name="age" id="age" data-vv-as="age" v-model="addMemberFields.age" v-validate="'required|numeric|max:2'" />
                                    <span v-show="errors.has('addMember.age')" class="text-danger">{{ errors.first('addMember.age') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <a class="btn btn-link full-width" v-on:click="cancelMember(3)">Cancel</a>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary full-width" type="submit">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade" id="popupAddLocality" tabindex="-1" role="dialog" aria-labelledby="popupTest" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!-- <div class="modal-header" style="padding-bottom: 10%;">
                        <button type="button" class="close black-color" v-on:click="closeLocalityPopup()">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>
                        <h5 class="modal-title" id="popupTest">
                           Choose Locality
                        </h5>
                    </div> -->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" v-on:click="closeLocalityPopup()">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Choose Locality</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="search-section">
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                              <div class="form-group mb-0">
                                  <label>Choose nearest if exact match not available</label>
                                  <div class="input-group mb-0">
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeAdd"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="addAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(2)"
                                        v-on:keyup.enter="searchLocality(2)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeAdd.select();" 
                                        v-validate="'required'">
                                      <!--<span class="input-group-btn">
                                          <button class="btn btn-link white-bg" type="button" @click="goBackLab()">
                                             GO
                                          </button>
                                      </span>-->
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-12">
                            <span>City/ Locality : <b> {{$localStorage.get('sc').cityName + ' / ' + (addAddressFields.locality ? addAddressFields.locality.locationName : '-')}}</b></span> <br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-body locality-search-popup">
                      <div>  
                          <div class="popular-test">
                            <ul class="p-0 m-0">
                              <li class="p-2 location-border" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 2)">
                                  {{item.locationName+'-'+item.locationZipCode}}
                                  <i v-if="addAddressFields.locality && item.locationId === addAddressFields.locality.locationId" class="fa fa-check green-color" style="font-size: 13px; margin-left:3px"></i>
                              </li>
                              <li v-if="locationList.length === 0" class="p-2 text-center location-border"> --- No Locations ---</li>
                              <li v-if="locationList.length === 0" class="p-2 color-blue text-center location-border" v-on:click.self="selectLocation($event, undefined, 3)">
                                  + Add Location
                              </li>
                              <li v-if="locationList.length !== 0" class="p-2 color-blue location-border" v-on:click.self="selectLocation($event, undefined, 3)">
                                  + Add Location
                              </li>
                            </ul>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popupEditLocality" tabindex="-1" role="dialog" aria-labelledby="popupTest" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!-- <div class="modal-header" style="padding-bottom: 10%;">
                        <button type="button" class="close black-color" v-on:click="closeLocalityPopup()">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>
                        <h5 class="modal-title" id="popupTest">
                           Choose Locality
                        </h5>
                    </div> -->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" v-on:click="closeLocalityPopup()">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Choose Locality</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="search-section">
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                              <div class="form-group mb-0">
                                  <label>Choose nearest if exact match not available</label>
                                  <div class="input-group mb-0">
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeEdit"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="editAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(1)"
                                        v-on:keyup.enter="searchLocality(1)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeEdit.select();" 
                                        v-validate="'required'">
                                      <!--<span class="input-group-btn">
                                          <button class="btn btn-link white-bg" type="button" @click="goBackLab()">
                                             GO
                                          </button>
                                      </span>-->
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-12">
                            <span>City/ Locality : <b> {{$localStorage.get('sc').cityName + ' / ' + (editAddressFields.locality ? editAddressFields.locality.locationName : '-')}}</b></span> <br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-body locality-search-popup">
                      <div>  
                          <div class="popular-test">
                            <ul class="p-0 m-0">
                              <li class="p-2 location-border" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 1)">
                                  {{item.locationName+'-'+item.locationZipCode}}
                                  <i v-if="editAddressFields.locality && item.locationId === editAddressFields.locality.locationId" class="fa fa-check green-color" style="font-size: 13px; margin-left:3px"></i>
                              </li>
                              <li v-if="locationList.length === 0" class="p-2 text-center location-border"> --- No Locations ---</li>
                              <li v-if="locationList.length === 0" class="p-2 color-blue text-center location-border" v-on:click.self="selectLocation($event, undefined, 3)">
                                  + Add Location
                              </li>
                              <li v-if="locationList.length !== 0" class="p-2 color-blue location-border" v-on:click.self="selectLocation($event, undefined, 3)">
                                  + Add Location
                              </li>
                            </ul>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import _ from 'underscore'
import dateFormat from 'dateformat'
import Datepicker from 'vuejs-datepicker'
import('./checkout')
export default {
  name: 'SelectAddress',
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
    if (!this.$localStorage.get('location') || !this.$localStorage.get('st')) {
      this.$router.push({ path: '/lab' })
    } else if (!this.$localStorage.get('sl')) {
      this.$router.push({ path: '/lab' })
    } else if (!this.$localStorage.get('ct')) {
      this.$router.push({ path: '/appointment' })
    } else if (!this.$localStorage.get('sa')) {
      this.$router.push({ path: '/address' })
    } else if (!this.$localStorage.get('sm')) {
      this.$router.push({ path: '/address' })
    }
    if (this.$localStorage.get('cou')) {
      this.$localStorage.remove('cou')
    }
  },
  components: {
    HeaderVue,
    FooterVue,
    Datepicker
  },
  data () {
    return {
      selectedLab: [],
      selectedProfileAndTest: [],
      activeAddress: [],
      activeMembers: [],
      testCosts: {},
      payinfo: [],
      addresses: {},
      members: {},
      isAddressActiveId: 0,
      isMemberActiveId: 0,
      isMe: true,
      addMemberForm: false,
      editMemberForm: false,
      addMemberFields: {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: ''
      },
      editMemberFields: {},
      addAddressForm: false,
      editAddressForm: false,
      locationList: [],
      addAddressFields: {},
      editAddressFields: {},
      stateCityDisp: '',
      showLocOther: false,
      couponCode: '',
      couponData: undefined,
      couponError: '',
      isSuccessCoupon: false,
      profileDetails: [],
      map: undefined,
      marker: undefined,
      mapCoordinates: undefined,
      editMemberObj: {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        dob: undefined,
        sex: '',
        photo: '',
        address: {},
        disabled: {
          from: new Date()
        }
      },
      isDobError: false,
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      addressZipCode: '',
      isInvalidPincode: false,
      onBlurKey: 'none',
      isCouponApplied: false,
      selectedLocality: undefined,
      isPage: true,
      isAddAddressPage: false,
      isEditAddressPage: false
    }
  },
  methods: {
    toogleAddress: function (type) {
      if (type === 1) {
        this.isPage = true
        this.isAddAddressPage = false
        this.isEditAddressPage = false
        $("body").css("overflow", "visible");
        // $('body').
      } else if (type === 2) {
        this.isPage = false
        this.isAddAddressPage = true
        this.isEditAddressPage = false
      } else if (type === 3) {
        this.isPage = false
        this.isAddAddressPage = false
        this.isEditAddressPage = true
      } else {
        this.isPage = true
        this.isAddAddressPage = false
        this.isEditAddressPage = false
      }
    },
    closeLocalityPopup: function () {
      this.onBlurKey = false
      if (this.isAddAddressPage) {
        if (this.addAddressFields.locality && this.addAddressFields.locality !== 'OTHER') {
          this.addAddressFields.zipcode = this.addAddressFields.locality ? this.addAddressFields.locality.locationName + '-' +this.addAddressFields.locality.locationZipCode : ''
        }
        $('#popupAddLocality').modal("hide")
        setTimeout(function() {
          this.$refs.newPincodeAdd.focus()
        }.bind(this), 300)
        
      } else if (this.isEditAddressPage) {
        if (this.editAddressFields.locality && this.editAddressFields.locality !== 'OTHER') {
          this.editAddressFields.zipcode = this.editAddressFields.locality ? this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode : ''
        }
        $('#popupEditLocality').modal("hide")
        setTimeout(function () {
          this.$refs.newPincodeEdit.focus()
        }.bind(this), 300)
      }
    },
    onFocusLocality: function () {
      if (this.isAddAddressPage) {
        $('#popupAddLocality').modal("show")
        this.addAddressFields.zipcode = ''
        this.showHideLocation(1)
        setTimeout(function() {
          this.$refs.pincodeAdd.focus()
          // this.$refs.pincodeAdd.select()
        }.bind(this),1000)
      } else if (this.isEditAddressPage) {
        $('#popupEditLocality').modal("show")
        this.editAddressFields.zipcode = ''
        this.showHideLocation(2)
        setTimeout(function () {
          this.$refs.pincodeEdit.focus()
        }.bind(this), 1000)
      }
      this.onBlurKey = true
    },
    showHideLocation: function (type) {
      let query = ''
      if (type === 1) {
        query = this.addAddressFields.zipcode
      } else if (type === 2) {
        query = this.editAddressFields.zipcode
      }
      this.onBlurKey = true
      if (query.length === 0) {
        this.locationList = this.$localStorage.get('sc').ActiveLocation
      } else {
        let locationFilter = this.$localStorage.get('sc').ActiveLocation.filter(function (locationVal) {
          let locality = locationVal.locationName
          // let city = locationVal.City ? locationVal.City.cityName : locationVal.City
          if (!locality) return false
          locality = locality.toLowerCase()
          return locality.includes(query.toLowerCase())
        }.bind(this));
        // if(locationFilter.length === 0) return false
        this.locationList = locationFilter
      }
    },
    goBackPopup: function () {
      if (this.isPage) {
        this.$router.push({path : '/appointment'})
      } else {
        this.toogleAddress(1)
      }
    },
    getNumberOfDays: function (dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        let noOfDays = new Date(this.year, this.month, 0).getDate()
        this.dobDate = []
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString())
        }
        if (dateVal) {
          this.ddate = dateVal
        } else {
          if (this.ddate) {
            var res = true
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false
              }
            }.bind(this))
            if (res) {
              this.ddate = ''
            }
          }
        }
      }
      return false      
    },
    goPayment: function () {
      if (!this.$localStorage.get('st')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select a test or profile`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        // alert('Please select a test or profile')
        return false
      } else if (!this.$localStorage.get('sl')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select a lab`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        // alert('Please select a lab')
        return false
      } else if (!this.$localStorage.get('ct')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select your apoointment date and time`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        // alert('Please select your apoointment date and time')
        return false
      } else if (!this.$localStorage.get('sa')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select or add your address`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        // alert('Please select your address')
        return false
      } else if (!this.$localStorage.get('sm')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select your member`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        // alert('Please select your member')
        return false
      } else {
        Vue.analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'PAYMENT INITIATED',
          contents: '',
          content_type: 'PAYMENT_INITIATED'
        })
        this.$router.push({path: '/payment'})
        return false
        this.razorPayAssign()
        // this.$router.push({ path: '/payment' })
        // return false
      }
    },
    calculateAge: function (birthday) { // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime()
      var ageDate = new Date(ageDifMs) // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
    getProfileOld: function () {
      try {
        this.profileDetails = []
        Promise.resolve(this.$GET('patient/getProfile', {})).then(function (res) {
          if (res.response_code === 0) {
            this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName
            this.profileDetails['firstName'] = res.response.Patient.firstName
            this.profileDetails['lastName'] = res.response.Patient.lastName
            this.profileDetails['photo'] = res.response.Patient.photo
            this.profileDetails['dob'] = dateFormat(res.response.Patient.dob, 'dd-mm-yyyy')
            this.profileDetails['phone1'] = res.response.Patient.phone1
            this.profileDetails['phone2'] = res.response.Patient.phone2
            this.profileDetails['sex'] = res.response.Patient.sex
            this.profileDetails['email'] = res.response.email
            if (res.response.Patient.dob) {
              this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob))
            } else {
              this.profileDetails['age'] = 0
            }
          }
        }.bind(this)).catch(function (err) {
          console.log(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    searchLocation: function (pincode) {
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'zipcode': pincode
          }
          Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    searchLocality: function (type) {
      this.isInvalidPincode = false
      if (type === 1) {
        if (!this.editAddressFields.locality || this.editAddressFields.zipcode !== (this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode)) {
          this.onBlurKey = 'block'
          this.editAddressFields.locality = undefined
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                'keyword': this.editAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              }
              Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                console.log(res)
                if (res.response_code === 0) {
                  this.locationList = res.response
                } else {
                  this.locationList = []
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      } else if (type === 2) {
        if (!this.addAddressFields.locality || this.addAddressFields.zipcode !== (this.addAddressFields.locality.locationName + '-' + this.addAddressFields.locality.locationZipCode)) {
          this.onBlurKey = 'block'
          // this.addAddressFields.locality = undefined
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                'keyword': this.addAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              }
              Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                console.log(res)
                if (res.response_code === 0) {
                  this.locationList = res.response
                } else {
                  this.locationList = []
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      }
    },
    closeBlock: function () {
      setTimeout(function () {
        this.onBlurKey = 'none'
      }.bind(this), 300)
    },
    selectLocation: function (event, obj, type) {
      this.isInvalidPincode = false
      if (type === 1) {
        this.showLocOther = false
        this.editAddressFields.locality = obj
        this.editAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode
        this.locationList = []
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName
        this.mapWithAddressEdit(this.editAddressFields, 2)
        this.closeLocalityPopup()
      } else if (type === 2) {
        this.showLocOther = false
        this.addAddressFields.locality = obj
        this.addAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode
        this.locationList = []
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName
        this.mapWithAddressAdd(this.addAddressFields, 2)
        this.closeLocalityPopup()
      } else if (type === 3) {
        this.addAddressFields.locality = 'OTHER'
        this.addAddressFields.zipcode = 'OTHER'
        this.editAddressFields.locality = 'OTHER'
        this.editAddressFields.zipcode = 'OTHER'
        this.showLocOther = true
        this.stateCityDisp = this.selectedLocality.City.cityName + ',' + this.selectedLocality.State.stateName
        this.closeLocalityPopup()
      }
    },
    getTestCosts: function (lab) {
      try {
        let labTestCosts = []
        if (this.$localStorage.get('sl')) {
          if ((this.$localStorage.get('sl').labTestList).length > 0) {
            _.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        let data = {
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        }
        Promise.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response
              let payinfo = {}
              payinfo['mrpTotal'] = res.response.mrp
              payinfo['phlebotomistFee'] = this.$phlebotomistFee
              payinfo['subTotal'] = (payinfo.mrpTotal + payinfo.phlebotomistFee)
              payinfo['labDiscount'] = res.response.youSaved
              payinfo['phlebotomyFeeWaiver'] = ((payinfo.mrpTotal - payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              payinfo['total'] = payinfo.subTotal - (payinfo.labDiscount + payinfo.phlebotomyFeeWaiver)
              payinfo['gst'] = Math.round(((payinfo.total) * this.$GSTFee) / 100)
              payinfo['grandTotal'] = (payinfo.total + payinfo.gst)
              this.payinfo = payinfo
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getAddress: function () {
      try {
        let data = {}
        Promise.resolve(this.$GET('patient/getAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.addresses = res.response
            if (this.isAddressActiveId === 0) {
              _.each(res.response, function (addresses) {
                if (this.selectedLocality.locationId === addresses.Location.locationId) {
                  if (this.isAddressActiveId > 0) {
                    return false
                  }
                  this.activeAddress = addresses
                  this.$localStorage.set('sa', addresses, 30 * 60 * 1000)
                  this.isAddressActiveId = addresses.addressId
                }
              }, this)
              return false
            }
            _.each(res.response, function (element) {
              if (element.addressId === this.isAddressActiveId) {
                if ((element.Location.CityControl.cityId === this.$localStorage.get('sc').cityId)) {
                  this.activeAddress = element
                  this.$localStorage.set('sa', element, 30 * 60 * 1000)
                  this.isAddressActiveId = element.addressId
                } else {
                  this.activeAddress = undefined
                  this.$localStorage.remove('sa')
                  this.isAddressActiveId = 0
                }
              }
            }, this)
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getMembers: function () {
      try {
        let data = {}
        Promise.resolve(this.$GET('patient/getUserAndFamily', data)).then(function (res) {
          this.members = res.response
          if (res.response.user) {
            if (this.$localStorage.get('sm')) {
              if (this.$localStorage.get('sm').userId === undefined) {
                this.isMemberActiveId = this.$localStorage.get('sm').memberId
                this.isMe = false
              } else {
                this.isMemberActiveId = this.$localStorage.get('sm').userId
                this.isMe = true
              }
            } else {
              this.isMemberActiveId = res.response.user.userId
              this.$localStorage.set('sm', res.response.user, 30 * 60 * 1000)
              this.isMe = true
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    addMember: function () {
      this.addMemberFields = {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: '',
        mobile: ''
      }
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 200)
      this.editMemberForm = false
      this.addAddressForm = false
      this.editAddressForm = false
      // this.addMemberForm = !(this.addMemberForm)
      $('#addPatientProfileModal').modal('show')
    },
    editMemberProfile: function (type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('show')
        this.getProfile()
      }
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                _.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address
                  }
                })
              }
              this.editMemberObj['firstName'] = res.response.Patient.firstName
              this.editMemberObj['lastName'] = res.response.Patient.lastName
              this.editMemberObj['email'] = res.response.email
              this.editMemberObj['phone1'] = res.response.Patient.phone1
              this.editMemberObj['phone2'] = res.response.Patient.phone2
              this.editMemberObj['dob'] = res.response.Patient.dob ? res.response.Patient.dob : undefined
              this.editMemberObj['sex'] = res.response.Patient.sex

              this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName
              this.profileDetails['firstName'] = res.response.Patient.firstName
              this.profileDetails['lastName'] = res.response.Patient.lastName
              this.profileDetails['photo'] = res.response.Patient.photo
              this.profileDetails['dob'] = dateFormat(res.response.Patient.dob, 'dd-mm-yyyy')
              this.profileDetails['phone1'] = res.response.Patient.phone1
              this.profileDetails['phone2'] = res.response.Patient.phone2
              this.profileDetails['sex'] = res.response.Patient.sex
              this.profileDetails['email'] = res.response.email
              if (res.response.Patient.dob) {
                this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob))
              } else {
                this.profileDetails['age'] = 0
              }
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                let dob = (res.response.Patient.dob).split('T')
                let dobDate = dob[0].split('-')
                this.year = dobDate[0]
                this.month = dobDate[1]
                this.getNumberOfDays(dobDate[2])
              }
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    },
    saveProfile: function () {
      this.isDobError = false
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          if (this.year.length !== 4 || this.month.length <= 0 || this.ddate.length <= 0) {
            this.isDobError = true
            return false
          }
          try {
            var data = {
              'firstName': this.editMemberObj.firstName,
              'lastName': this.editMemberObj.lastName,
              'phone1': this.editMemberObj.phone1,
              'phone2': this.editMemberObj.phone2,
              'photo': '',
              'sex': this.editMemberObj.sex,
              // 'dob': dateFormat(this.editMemberObj.dob, 'yyyy-mm-dd', true),
              'dob': this.year + '-' + this.month + '-' + this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            }
            Promise.resolve(this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile')
                var userDetails = {
                  'username': this.editMemberObj.firstName + ' ' + this.editMemberObj.lastName,
                  'firstName': this.editMemberObj.firstName,
                  'lastName': this.editMemberObj.lastName,
                  'phone1': this.editMemberObj.phone1,
                  'dob': dateFormat(this.editMemberObj.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                }
                this.$localStorage.set('profile', userDetails, 0)
                this.getMembers()
                $('#editMemberProfileModal').modal('hide')
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:saveProfile', e)
          }
        }
      })
    },
    editMember: function (family) {
      this.addAddressForm = false
      this.editAddressForm = false
      this.addMemberForm = false
      this.editMemberFields = family
      $('#editPatientProfileModal').modal('show')
      // this.editMemberForm = true
    },
    cancelMember: function (type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('hide')
      } else if (type === 2) {
        $('#editPatientProfileModal').modal('hide')
        this.editMemberFields = {}
      } else if (type === 3) {
        $('#addPatientProfileModal').modal('hide')
        this.addMemberFields = {
          firstName: '',
          lastName: '',
          sex: 'M',
          age: ''
        }
      }
      this.errors.items = []
      return false
    },
    saveMember: function () {
      try {
        this.$validator.validateAll('addMember').then((result) => {
          if (result) {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                firstName: this.addMemberFields.firstName,
                lastName: this.addMemberFields.lastName,
                sex: this.addMemberFields.sex,
                mobile: this.addMemberFields.mobile,
                age: this.addMemberFields.age
              }
              Promise.resolve(this.$POST('patient/saveFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000)
                  this.isMe = false
                  this.getMembers()
                  this.addMemberForm = false
                  this.editMemberForm = false
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.addMemberFields = {}
                  this.errors.items = []
                  $('#addPatientProfileModal').modal('hide')
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    setActiveMemberId: function (member) {
      if (member.userId) {
        this.isMe = true
      } else {
        this.isMe = false
      }
      this.$localStorage.set('sm', member, 30 * 60 * 1000)
    },
    deleteMember: function (member) {
      try {
        let confirmMemberFn = function () {
          if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
            var data = {
              memberId: member.memberId
            }
            Promise.resolve(this.$POST('patient/deleteFamilyMember', data)).then(function (res) {
              if (res.response_code === 0) {
                this.getMembers()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }.bind(this)
        this.$Simplert.open({
          title: 'Confirm',
          message: 'Are you sure confirm, you want to delete this member?',
          type: 'info',
          useConfirmBtn: true,
          onConfirm: confirmMemberFn,
          customConfirmBtnText: 'Ok',
          customCloseBtnText: 'Cancel',
          disableOverlayClick: true
        })
      } catch (e) {
        console.log(e)
      }
    },
    updateMember: function () {
      try {
        this.$validator.validateAll('editMember').then((result) => {
          if (result) {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                memberId: this.editMemberFields.memberId,
                firstName: this.editMemberFields.firstName,
                lastName: this.editMemberFields.lastName,
                sex: this.editMemberFields.sex,
                mobile: this.editMemberFields.mobile,
                age: this.editMemberFields.age
              }
              Promise.resolve(this.$POST('patient/updateFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000)
                  this.isMemberActiveId = this.$localStorage.get('sm').memberId
                  this.isMe = false
                  this.getMembers()
                  this.addMemberForm = false
                  this.editMemberForm = false
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.editMemberFields = {}
                  $('#editPatientProfileModal').modal('hide')
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    selectAddress: function (address) {
      if (address.Location.CityControl.cityId === this.$localStorage.get('location').CityControl.cityId) {
        this.isAddressActiveId = address.addressId
        this.$localStorage.set('sa', address, 30 * 60 * 1000)
      } else {
        let SecAlertObj = {}
        SecAlertObj = {
          title: 'Alert',
          message: `The selected pickup address city (${address.Location.CityControl.cityName}) is not within the searched city (${this.$localStorage.get('location').CityControl.cityName}). Kindly provide the correct address.`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        }
        this.$Simplert.open(SecAlertObj)
      }
    },
    saveAddress: function () {
      try {
        this.isInvalidPincode = false
        this.$validator.validateAll('addAddress').then((result) => {
          if (result) {
            if (this.addAddressFields.zipcode && this.addAddressFields.zipcode.length > 0 && !this.addAddressFields.locality && this.addAddressFields.locality !== 'OTHER') {
              this.isInvalidPincode = true
              return false
            }
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'addressName': this.addAddressFields.addressName,
                'flatNo': this.addAddressFields.flatNo,
                'address': this.addAddressFields.address,
                'landmark': this.addAddressFields.landmark,
                'locationOther': (this.addAddressFields.locationOther) ? this.addAddressFields.locationOther : '',
                'mobile': this.addAddressFields.mobile,
                'isDefault': 0,
                'coordinates': this.mapCoordinates
              }
              if (this.addAddressFields.locality === 'OTHER') {
                data['locationId'] = 0
                data['cityId'] = this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 2
                data['stateId'] = this.$localStorage.get('sc') ? (this.$localStorage.get('sc').State ? this.$localStorage.get('sc').State.stateId : 2) : 2
                data['zipCode'] = this.addAddressFields.locationPincode
                if (isNaN(this.addAddressFields.locationPincode)) {
                  this.otherPincodeError = true
                  return false
                }
              } else {
                data['locationId'] = this.addAddressFields.locality.locationId
                data['cityId'] = this.addAddressFields.locality.City.cityId
                data['stateId'] = this.addAddressFields.locality.State.stateId
                data['zipCode'] = this.addAddressFields.locality.locationZipCode
              }
              Promise.resolve(this.$POST('patient/saveAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.activeAddress = res.response
                  this.$localStorage.set('sa', res.response, 30 * 60 * 1000)
                  this.isAddressActiveId = res.response.addressId
                  this.getAddress()
                  this.addAddressFields = {}
                  this.toogleAddress(1)
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: `<div style="text-align: left; line-height: 20px;">
                              <p>${res.response_message}</p>
                            </div>`,
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  })
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    updateAddress: function () {
      try {
        this.isInvalidPincode = false
        this.$validator.validateAll('editAddress').then((result) => {
          if (result) {
            if (this.editAddressFields.zipcode && this.editAddressFields.zipcode.length > 0 && !this.editAddressFields.locality && this.editAddressFields.locality !== 'OTHER') {
              this.isInvalidPincode = true
              return false
            }
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'addressId': this.editAddressFields.addressId,
                'addressName': this.editAddressFields.addressName,
                'address': this.editAddressFields.address,
                'flatNo': this.editAddressFields.flatNo,
                'landmark': this.editAddressFields.landmark,
                'locationOther': (this.editAddressFields.locationOther) ? this.editAddressFields.locationOther : '',
                'mobile': this.editAddressFields.mobile,
                'isDefault': 0,
                'coordinates': this.mapCoordinates
              }
              if (this.editAddressFields.locality === 'OTHER') {
                data['locationId'] = 0
                data['cityId'] = this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
                data['stateId'] = this.$localStorage.get('sc') ? (this.$localStorage.get('sc').State ? this.$localStorage.get('sc').State.stateId : 2) : 2
                data['zipCode'] = this.editAddressFields.locationPincode
              } else {
                data['locationId'] = this.editAddressFields.locality.locationId
                data['cityId'] = this.editAddressFields.locality.City.cityId
                data['stateId'] = this.editAddressFields.locality.State.stateId
                data['zipCode'] = this.editAddressFields.locality.locationZipCode
              }
              Promise.resolve(this.$POST('patient/updateAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.isAddressActiveId = this.editAddressFields.addressId
                  this.getAddress()
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.editAddressFields = {}
                  this.toogleAddress(1)
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: `<div style="text-align: left; line-height: 20px;">
                              <p>${res.response_message}</p>
                            </div>`,
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  })
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log('error', e)
      }
    },
    addAddress: function (value) {
      this.isInvalidPincode = false
      this.addMemberForm = false
      this.editMemberForm = false
      this.addAddressForm = false
      this.editAddressForm = false
      this.showLocOther = false
      let addFields = []
      this.addressZipCode = ''
      addFields['addressId'] = ''
      addFields['addressName'] = this.$localStorage.get('profile').username
      addFields['address'] = ''
      addFields['zipcode'] = this.$localStorage.get('location') ? (this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode) : ''
      addFields['locationOther'] = ''
      addFields['mobile'] = this.$localStorage.get('profile').phone1
      addFields['isDefault'] = 0
      addFields['coordinates'] = ''
      addFields['state'] = undefined
      if (this.$localStorage.get('location') && this.$localStorage.get('location').City && this.$localStorage.get('location').State) {
        addFields['cityId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').City.cityId : 2
        addFields['stateId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').State.stateId : 2
        addFields['locationId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').locationId : 0
        addFields['stateCityDisp'] = this.$localStorage.get('location').City.cityName + ', ' + this.$localStorage.get('location').State.stateName
        addFields['locality'] = this.$localStorage.get('location')
        this.stateCityDisp = addFields['stateCityDisp']
      } else {
        addFields['locality'] = ''
      }
      this.addAddressFields = addFields
      this.toogleAddress(2)
      this.mapWithAddressAdd(this.addAddressFields, 2)
      setTimeout(function () {
        $(window).scrollTop(0)
      }.bind(this), 300)
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        setTimeout(function () {
          this.onchangePincode()
        }.bind(this), 300)
        return true
      }
    },
    onchangePincode: function () {
      if (this.addAddressFields.zipcode.length !== 6) {
        console.log(this.addAddressFields.zipcode)
        return false
      }
      var data = {
        'pincode': this.addAddressFields.zipcode
      }
      Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response
        } else {
          this.locationList = []
          this.addAddressFields.locality = ''
        }
      }.bind(this))
    },
    isNumberEdit: function (evt) {
      evt = (evt) ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      console.log(charCode)
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onchangePincodeEdit: function () {
      if (this.editAddressFields.zipcode.length !== 6) {
        return false
      }
      var data = {
        'pincode': this.editAddressFields.zipcode
      }
      Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response
        } else {
          this.locationList = []
          this.editAddressFields.locality = ''
        }
      }.bind(this))
    },
    cancelModalPopup: function () {
      $(window).scrollTop(0)
      this.toogleAddress(1)
      this.errors.items = []
      this.addAddressFields = {}
      this.editAddressFields = {}
      this.addAddressForm = false
      this.editAddressForm = false
    },
    addressChanged: function (type) {
      if (type === 1) {
        this.mapWithAddressAdd(this.addAddressFields, 2)
      } else {
        this.mapWithAddressEdit(this.editAddressFields, 2)
      }
    },
    editAddress: function (value) {
      try {
        // if(value.Location.CityControl.cityId !== this.$localStorage.get('sc').cityId){
        //     let SecAlertObj = {
        //       title: 'Alert',
        //       message: `This address belongs to ${value.Location.CityControl.cityName} city. Please choose another or add new address.`,
        //       type: 'warning',
        //       disableOverlayClick: true,
        //       showXclose: true,
        //       useConfirmBtn: false,
        //       customCloseBtnText: 'OK'
        //     }
        //     this.$Simplert.open(SecAlertObj)
        //     return false
        // }
        this.isInvalidPincode = false
        this.addMemberForm = false
        this.editMemberForm = false
        this.addAddressForm = false
        this.editAddressForm = false
        this.showLocOther = false
        let editFields = []
        editFields['addressId'] = value.addressId
        editFields['addressName'] = value.addressName
        editFields['address'] = value.address
        editFields['flatNo'] = value.flatNo
        editFields['landmark'] = value.landmark
        editFields['zipcode'] = value.Location.locationName + '-' + value.Location.locationZipCode
        editFields['locationOther'] = ''
        editFields['mobile'] = value.mobile
        editFields['isDefault'] = 0
        editFields['coordinates'] = value.coordinates
        editFields['state'] = undefined
        editFields['locality'] = value.Location
        this.toogleAddress(3)
        this.mapWithAddressEdit(value, 1)
        setTimeout(function () {
          $(window).scrollTop(0)
        }, 500)
        editFields['cityId'] = (value.Location) ? value.Location.City.cityId : 2
        editFields['stateId'] = (value.Location) ? value.Location.State.stateId : 2
        editFields['locationId'] = (value.Location) ? value.Location.locationId : 0
        editFields['stateCityDisp'] = value.Location.City.cityName + ', ' + value.Location.State.stateName
        this.editAddressFields = editFields
        this.stateCityDisp = editFields['stateCityDisp']
        // var data = {
        //   'pincode': value.zipCode
        // }
        // Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        //   if (res.response.length > 0) {
        //     this.locationList = res.response
        //     _.each(res.response, function (element) {
        //       if (element.locationId === value.Location.locationId) {
        //         editFields['cityId'] = (element) ? element.City.cityId : 2
        //         editFields['stateId'] = (element) ? element.State.stateId : 2
        //         editFields['locationId'] = (element) ? element.locationId : 0
        //         editFields['stateCityDisp'] = element.City.cityName + ', ' + element.State.stateName
        //         // myMap(undefined, 'map', 'coordinates_popup', this.editAddressFields.coordinates)
        //         if (element) {
        //           editFields['locality'] = element
        //         } else {
        //           editFields['locality'] = ''
        //         }
        //       }
        //     }, this)
        //     // this.editAddressForm = true
        //     this.editAddressFields = editFields
        //     this.stateCityDisp = editFields['stateCityDisp']
        //   }
        // }.bind(this)).catch(function (err) {
        //   console.error(err)
        // })
      } catch (e) {
        console.log('error', e)
      }
    },
    mapWithAddressAdd: function (value, type) {
      this.mapCoordinates = undefined
      var address = ''
      var location = ''
      var stateCity = value.stateCityDisp
      this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      })
      if (type === 2) {
        address = value.address
        console.log(value)
        if (value.locality === 'OTHER') {
          location = value.locationOther
        } else {
          location = value.locality.locationName
        }
        this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var geocoder = new google.maps.Geocoder()
        geocoder.geocode({
          'address': address && location ? address + ' , ' + location + ', ' + stateCity : (address && !location ? address + ', ' + stateCity : (!address && location ? location + ', ' + stateCity : ''))
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            })
            var latitude = results[0].geometry.location.lat()
            var longitude = results[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            this.mapCoordinates = latitude + ',' + longitude
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
          } else {
            this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
              zoom: 15,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            })
            geocoder.geocode({ 'address': location + ', '+ stateCity }, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location)
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                })
                var latitude = resp[0].geometry.location.lat()
                var longitude = resp[0].geometry.location.lng()
                var latlng = new google.maps.LatLng(latitude, longitude)
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize')
                  this.map.setCenter(latlng)
                  google.maps.event.trigger(this.map, 'resize')
                }.bind(this), 1000)
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
              } else {
                geocoder.geocode({
                  'address': stateCity
                }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location)
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    })
                    var latitude = resp[0].geometry.location.lat()
                    var longitude = resp[0].geometry.location.lng()
                    var latlng = new google.maps.LatLng(latitude, longitude)
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize')
                      this.map.setCenter(latlng)
                      google.maps.event.trigger(this.map, 'resize')
                    }.bind(this), 1000)
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status)
                  }
                }.bind(this))
              }
            }.bind(this))
          }
        }.bind(this))
      } else {
        var geocoder = new google.maps.Geocoder()
        geocoder.geocode({
          'address': stateCity
        }, function (resp, status) {
          if (status === 'OK') {
            this.map.setCenter(resp[0].geometry.location)
            this.marker = new google.maps.Marker({
              map: this.map,
              position: resp[0].geometry.location
            })
            var latitude = resp[0].geometry.location.lat()
            var longitude = resp[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
            this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
          } else {
            console.log('Geocode was not successful for the following reason: ' + status)
          }
        }.bind(this))
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng
        })
        this.marker.setMap(this.map)
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng()
      }.bind(this))
    },
    mapWithAddressEdit: function (value, type) {
      this.mapCoordinates = undefined
      var address = ''
      var location = ''
      var city = value.City ? value.City.cityName: ''
      var state = value.State ? value.State.stateName: ''
      var stateCity =  city + ', ' + state
      if (type === 1) {
        address = value.address
        location = value.Location.locationName
        this.mapCoordinates = value.coordinates
      } else {
        address = value.address
        if (value.locality === 'OTHER') {
          location = value.locationOther
        } else {
          location = value.locality.locationName
        }
      }
      if (this.mapCoordinates && this.mapCoordinates.length > 0) {
        var cordinatesArray = this.mapCoordinates.split(',')
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var latitude = parseFloat(cordinatesArray[0], 8)
        var longitude = parseFloat(cordinatesArray[1], 8)
        var latlng = new google.maps.LatLng(latitude, longitude)
        this.marker = new google.maps.Marker({
          map: this.map,
          position: latlng
        })
        setTimeout(function () {
          this.map.setCenter(latlng)
          google.maps.event.trigger(this.map, 'resize')
          this.map.setCenter(latlng)
          google.maps.event.trigger(this.map, 'resize')
        }.bind(this), 1000)
      } else {
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var geocoder = new google.maps.Geocoder()

        geocoder.geocode({
          'address': address + ' , ' + location + ', ' + stateCity
        }, function (results, status) {
          console.log(results)
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            })
            var latitude = results[0].geometry.location.lat()
            var longitude = results[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            console.log(latitude + ',' + longitude)
            this.mapCoordinates = latitude + ',' + longitude
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
          } else {
            geocoder.geocode({'address': location  + ', '+stateCity}, function (resp, status) {
              console.log(resp)
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location)
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                })
                var latitude = resp[0].geometry.location.lat()
                var longitude = resp[0].geometry.location.lng()
                var latlng = new google.maps.LatLng(latitude, longitude)
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize')
                  this.map.setCenter(latlng)
                  google.maps.event.trigger(this.map, 'resize')
                }.bind(this), 1000)
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
              } else {
                geocoder.geocode({ 'address': stateCity }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location)
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    })
                    var latitude = resp[0].geometry.location.lat()
                    var longitude = resp[0].geometry.location.lng()
                    var latlng = new google.maps.LatLng(latitude, longitude)
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize')
                      this.map.setCenter(latlng)
                      google.maps.event.trigger(this.map, 'resize')
                    }.bind(this), 1000)
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status)
                  }
                }.bind(this))
              }
            }.bind(this))
          }
        }.bind(this))
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng
        })
        this.marker.setMap(this.map)
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng()
      }.bind(this))
    },
    showAddOtherLocation: function () {
      this.showLocOther = false
      if (this.addAddressFields.locality === 'OTHER') {
        this.showLocOther = true
        this.stateCityDisp = stateCity
      } else {
        let jsonLocality = this.addAddressFields.locality
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName
      }
      this.mapWithAddressAdd(this.addAddressFields, 2)
    },
    showEditOtherLocation: function () {
      this.showLocOther = false
      if (this.editAddressFields.locality === 'OTHER') {
        this.showLocOther = true
        this.stateCityDisp = this.stateCityDisp
      } else {
        let jsonLocality = this.editAddressFields.locality
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName
      }
      this.mapWithAddressEdit(this.editAddressFields, 2)
    },
    deleteAddress: function (addressId) {
      let confirmFn = function () {
        let data = {
          addressId: addressId
        }
        Promise.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.getAddress()
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      }.bind(this)
      let obj = {}
      obj = {
        title: 'Confirm',
        message: 'Are you sure confirm, you want to delete this address?',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      }
      this.$Simplert.open(obj)
      // let r = confirm('Are you sure you want to delete?')
      // if (r === true) {
      //   try {
      //     let data = {
      //       addressId: addressId
      //     }
      //     Promise.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
      //       if (res.response.length > 0) {
      //         this.getAddress()
      //       }
      //     }.bind(this)).catch(function (err) {
      //       console.error(err)
      //     })
      //   } catch (e) {
      //     console.log('error', e)
      //   }
      // }
    },
    applyCoupon: function () {
      this.$validator.validateAll('coupon').then((result) => {
        if (result) {
          try {
            this.couponError = ''
            this.isSuccessCoupon = false
            if (this.couponCode === '') {
              this.couponError = 'Please enter coupon code'
              return false
            }
            let data = {
              'coupon_code': (this.couponCode).toUpperCase()
            }

            if (this.$localStorage.get('sl')) {
              data['labId'] = this.$localStorage.get('sl').labId
              let labProfileIds = []
              if (this.$localStorage.get('sl') && this.$localStorage.get('sl').labTestList.length > 0) {
                this.$localStorage.get('sl').labTestList.forEach(function (element) {
                  if (element.labProfileId > 0) {
                    labProfileIds.push(element.labProfileId)
                  }
                })
              }
              data['labProfileIds'] = labProfileIds
            } else {
              data['labId'] = 0
              data['labProfileIds'] = []
            }

            if (this.$localStorage.get('profile')) {
              data['email'] = this.$localStorage.get('profile').email
            } else {
              data['email'] = ''
            }
            Promise.resolve(this.$POST('patient/applyCoupon', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.set('cou', res.response, 30 * 60 * 1000)
                this.isCouponApplied = true
                this.couponData = res.response
                this.couponError = ''
                if (res.response.coupon_percentage > 0) {
                  this.isSuccessCoupon = true
                  this.couponError = res.response.coupon_percentage + '% '
                } else {
                  this.isSuccessCoupon = true
                  this.couponError = 'Rs.' + res.response.coupon_price + ' '
                }
                this.getCartPaymentDetails()
              } else {
                this.$localStorage.remove('cou')
                if (res.response_code === 4) {
                  this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')'
                } else {
                  this.couponError = res.response_message
                }
                this.getCartPaymentDetails()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.log('error', e)
          }
        }
      })
    },
    removeCoupon: function () {
      this.$localStorage.remove('cou')
      this.getCartPaymentDetails()
      this.isCouponApplied = false
      this.couponData = undefined
      this.couponCode = ''
    },
    getCartPaymentDetails: function () {
      try {
        let labTestCosts = []
        if (this.$localStorage.get('sl')) {
          if ((this.$localStorage.get('sl').labTestList).length > 0) {
            _.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        var data = {
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts,
          'couponCode': (this.$localStorage.get('cou')) ? this.$localStorage.get('cou').coupon_code : '',
          'couponId': (this.$localStorage.get('cou')) ? this.$localStorage.get('cou').couponId : '0'
        }
        Promise.resolve(this.$POST('patient/cartPaymentDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              let payinfo = {}
              payinfo['mrpTotal'] = res.response.mrpTotal
              payinfo['phlebotomistFee'] = res.response.phlebotomistFee
              payinfo['subTotal'] = res.response.subTotal
              payinfo['labDiscount'] = res.response.labDiscount
              payinfo['waiverDiscountApplyFee'] = res.response.waiverDiscountApplyFee
              payinfo['phlebotomyFeeWaiver'] = res.response.phlebotomyFeeWaiver
              payinfo['total'] = (res.response.mrpTotal - res.response.labDiscount) // res.response.total
              payinfo['gst'] = res.response.gst
              payinfo['couponFee'] = res.response.couponFee
              payinfo['grandTotal'] = res.response.grandTotal
              payinfo['couponCode'] = res.response.couponCode
              payinfo['couponId'] = res.response.couponId
              if ((res.response.grandTotal) <= 0) {
                this.payinfo.grandTotal = 0
                payinfo['grandTotal'] = 0
              }
              payinfo['priceDetails'] = res.response.priceDetails
              this.payinfo = payinfo
            }
          }
          this.$hidePageLoading()
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    razorPayAssign: function () {
      if (this.payinfo && this.profileDetails) {
        var self = this
        var options = {
          'key': this.$razorpay_key,
          'amount': Math.ceil(this.payinfo.grandTotal) * 100, // 2000 paise = INR 20
          'name': 'Labotist Private Limited',
          'description': 'Health & Fitness',
          'image': 'https://labotist.com/dist/images/logo-svg.svg',
          'handler': function (response) {
            // alert(response.razorpay_payment_id)
            self.saveRequest(response.razorpay_payment_id)
          },
          'prefill': {
            'name': this.profileDetails.username,
            'email': this.profileDetails.email,
            'contact': this.profileDetails.phone1
          },
          'notes': {
            'address': this.profileDetails.username + ', ' + this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode
          },
          'theme': {
            'color': '#057dc2',
            'emi_mode': false
          }
        }
        Razorpay(options).open()
      }
    },
    saveRequest: function (paymentId) {
      this.$showPageLoading()
      try {
        let paymentData = {
          paymentId: paymentId
        }
        Promise.resolve(this.$GET('payment/fetch', paymentData)).then(function (rzpInfo) {
          if (rzpInfo.response_code === 0) {
            let totalPaidCost = 0
            if (rzpInfo) {
              totalPaidCost = (rzpInfo.response.amount) / 100
            }
            let timezone = new Date().getTimezoneOffset()
            let appointmentDate = this.$localStorage.get('ct').dateFormatMoment
            let appointmentTimeFrom = this.$localStorage.get('ct').startTime
            let appointmentTimeTo = this.$localStorage.get('ct').endTime
            let appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime
            let appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime
            // alert(this.$localStorage.get('ct').fromDateTime)
            // let appointmentTimeFromTimeZone = dateFormat(this.$localStorage.get('ct').fromDateTime, 'HH:MM:ss')
            // alert(3)
            // let appointmentTimeToTimeZone = dateFormat(this.$localStorage.get('ct').toDateTime, 'HH:MM:ss')
            // alert(4)
            // let appointmentDateTimeFromTimeZone = dateFormat(this.$localStorage.get('ct').fromDateTime, 'yyyy-mm-dd HH:MM:ss', true)
            // alert(5)
            // let appointmentDateTimeToTimeZone = dateFormat(this.$localStorage.get('ct').toDateTime, 'yyyy-mm-dd HH:MM:ss', true)
            // alert(6)
            let data = {
              'paymentId': paymentId,
              'labId': this.$localStorage.get('sl').labId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              // 'appointmentDateTimeFromTimeZone': appointmentDateTimeFromTimeZone,
              // 'appointmentDateTimeToTimeZone': appointmentDateTimeToTimeZone,
              // 'appointmentTimeFromTimeZone': appointmentTimeFromTimeZone,
              // 'appointmentTimeToTimeZone': appointmentTimeToTimeZone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': totalPaidCost,
              'actualCost': this.payinfo.subTotal,
              'discountCost': (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver),
              'gstCost': (this.payinfo.gstCost),
              'couponCost': (this.payinfo.couponFee),
              'couponCode': (this.payinfo.couponCode),
              'couponId': (this.payinfo.couponId),
              'totalCost': (this.payinfo.grandTotal),
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sm').mobile,
              'pickupAddress': this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates
            }

            // alert(JSON.stringify(data))

            let labTests = []
            let labProfiles = []
            if (this.$localStorage.get('st').length > 0) {
              _.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId)
                } else {
                  labTests.push(element.testId)
                }
              })
            }
            data.test = labTests
            data.profile = labProfiles
            // alert(JSON.stringify(data))
            Promise.resolve(this.$POST('patient/saveRequest', data)).then(function (res) {
              if (res.response_code === 0) {
                this.clearRequestSessions()
                global.successId = res.response.requestId
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                })
                this.$router.push({ path: '/success', params: { sample: 'hi' } })
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err)
            })
          }
        }.bind(this)).catch(function (err) {
          // alert(JSON.stringify(err))
          console.log('METHOD:saveRequest', err)
        })
      } catch (err) {
        // alert(JSON.stringify(err))
        console.log('METHOD:saveRequest', err)
      }
    },
    clearRequestSessions: function () {
      this.$localStorage.remove('location')
      this.$localStorage.remove('st')
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('sa')
      this.$localStorage.remove('step')
      this.$localStorage.remove('cou')
    }
  },
  created () {
    this.toogleAddress(1)
    this.selectedLab = []
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl')
    }
    if (this.$localStorage.get('location')) {
      this.selectedLocality = this.$localStorage.get('location')
    }

    this.selectedProfileAndTest = []
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st')
    }

    this.activeAddress = []
    if (this.$localStorage.get('sa')) {
      this.activeAddress = this.$localStorage.get('sa')
      this.isAddressActiveId = this.$localStorage.get('sa').addressId
    }

    this.activeMembers = []
    if (this.$localStorage.get('sm')) {
      this.activeMembers = this.$localStorage.get('sm')
      if (this.$localStorage.get('sm').userId === undefined) {
        this.isMemberActiveId = this.$localStorage.get('sm').memberId
      } else {
        this.isMemberActiveId = this.$localStorage.get('sm').userId
      }
    }
    if (this.$localStorage.get('cou')) {
      this.isCouponApplied = true
      this.couponData = this.$localStorage.get('cou')
      if (this.$localStorage.get('cou').coupon_percentage > 0) {
        this.isSuccessCoupon = true
        this.couponError = this.$localStorage.get('cou').coupon_percentage + '% '
      } else {
        this.isSuccessCoupon = true
        this.couponError = 'Rs.' + this.$localStorage.get('cou').coupon_price + ' '
      }
    }
    this.getProfile()
    this.getTestCosts()
    this.getAddress()
    this.getMembers()
    this.searchLocation(this.$localStorage.get('pincode'))
    this.getCartPaymentDetails()
    let year = (new Date()).getFullYear()
    let endYear = year - 120
    for (let i = year; i > endYear; i--) {
      this.dobYears.push(i.toString())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/Book/Secure/Address.vue